import { Typography } from '@mui/material'
import { onIdentifierClick } from '$func/identifier'

export function identifierRenderer(key: string, result: string[]) {
  const identifier = result[0].slice(1)
  return (
    <Typography
      key={key}
      variant="paragraph3"
      color="secondary"
      sx={{ cursor: 'pointer', fontSize: '14px' }}
      onClick={async e => {
        e.stopPropagation()
        await onIdentifierClick(identifier)
      }}
      dir="ltr"
    >
      {result[0]}
    </Typography>
  )
}
